if (typeof window !== 'undefined') {
  window.Polaris = window.Polaris || {};
  window.Polaris.VERSION = '10.49.1';
}
const DEFAULT_LOCALE = 'en';
const SUPPORTED_LOCALES = ['cs', 'da', 'de', 'en', 'es', 'fi', 'fr', 'it', 'ja', 'ko', 'nb', 'nl', 'pl', 'pt-BR', 'pt-PT', 'sv', 'th', 'tr', 'vi', 'zh-CN', 'zh-TW'];

export { DEFAULT_LOCALE, SUPPORTED_LOCALES };
